module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0009.af07a8ec.jpg";